import type { TFunction } from 'i18next';

import { flagsWithGeoAdressString } from '@/components/common/FlagsWithGeoAddr';
import type { DetailedFuelFilling } from '@/generated/model';
import { fulldate } from '@/utilities/dateUtils';

import type { RefuelDataGridRow } from '../../../types/RefuelDataGridRow.types';

export function mapRefuelsToRows(refuels: DetailedFuelFilling[] | undefined, t: TFunction): RefuelDataGridRow[] {
  return (
    refuels?.map((row) => ({
      id: `${row.fuelFillingTimeMicros}-${row.fuelFillingPosition}-${row.fillAmount}`,
      refuelDate: fulldate(row.fuelFillingTimeMicros, t),
      refuelPlace: flagsWithGeoAdressString({
        countryCode: row.countryCode,
        geocodedAddress: row.fuelFillingPosition,
      }),
      startFuelLevel: row.fillStartLevel,
      amountRefuels: row.fillAmount,
      stopFuelLevel: row.fillEndLevel,
    })) ?? []
  );
}
